import React, { useEffect, useState, useRef } from 'react'
import axios, {AxiosResponse} from 'axios';
import "react-datepicker/dist/react-datepicker.css";
import { Api } from "../../../../helpers/Api";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from '../Spinner/LoadingSpinner';
import { connect } from "react-redux";
import { jsPDF } from "jspdf";
import Blob from "blob";
import html2canvas from 'html2canvas';


const headLogo = {
  position: 'absolute',
  width: '100px',
  height: '40px',
  top: 0,
  left: '3%',
}

const headName = {
  position: 'absolute',
  top: 0,
  textAlign: 'center',
  left: '30%',
}

const headingTabledata = {
  marginLeft: 'auto',
  marginRight: 'auto',
  border: '.5px solid black'
}

const tabledata = {
  marginLeft: 'auto',
  marginRight: 'auto',
  borderLeft: '.5px solid black',
  borderRight: '.5px solid black',
  borderBottom: '.5px solid black'
}

const normalText = {
  textAlign: 'justify',
  fontSize: '2.27vh',
  padding: '10px'
}

const table = {
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: "30px",
  minHeight: "387px"
}

const td = {
  fontSize: '2.27vh',
  width: '150px',
  padding: '10px',
  borderRight: '.5px solid black',
}

const textAlign = {
  textAlign: 'left',
  fontSize: '2.27vh',
  padding: '10px',
}

const HeadingAligne = {
  fontSize:'2.27vh',
  textAlign: 'center',
  fontWeight: 'bold',
}

const justifyAlign = {
  fontSize: '2.27vh',
  textAlign: 'justify'
}

const pageCss = {
  position: 'absolute',
  fontSize: '2.27vh',
  bottom: 0,
  right: 2,
}

const eventName = {
  position: 'absolute',
  fontSize: '2.27vh',
  bottom: 0,
  left: 2,
}

const EventReport = ({ user, ...props }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [count, setCount] = useState(0);
  const params = useParams();
  const navigate = useNavigate();

  const loadData = (id) => {
    if (id === 'new') {
      return;
    }

    Api.call(`/getReport/${id}`).then(post => {
      setData(post)
      dataSet(post)
      setTimeout(() => {
      }, 2000)
    }).catch(console.log).finally(() => {

    });
  };


  const dataSet = async(data)=>{
    const srcs = [];
    let imagecount = 0; 
    data?.EventsPhotos?.forEach(element => {
        axios.get(element?.imageUrl.replace("itmatic.io", "codebrigade.in"), { responseType: 'blob' }).then((response) => {
          return response.data;
      })
      .then((blob) => {
        const reader = new FileReader();

        // Use a promise to handle FileReader
        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                resolve(reader.result); // Base64 string
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob); // Read the Blob as Base64
        });
    })
    .then((base64String) => {
        var key = element?.imageUrl
      srcs[key]={"url":base64String,"caption":element?.caption};
      imagecount++;
      if (imagecount ==  data?.EventsPhotos?.length) {
        setImages(srcs);
        setCount(imagecount);
    }
    })
      .catch((error) => {
          console.error('Error fetching the image:', error);
      })
   });
  }
  
  useEffect(() => {
    window.resizeTo(100, 100);
    if (!user.user) {
      navigate(`/`);
    }
    else if (params.id) {
      loadData(params.id)
    }
  }, [params.id])

  const nl2br = (str = '', is_xhtml) => {
    if (typeof str === 'undefined' || str === null) {
      return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    str = (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    return str;
  }

  useEffect(() => {
    if (count>0) {
      document.getElementById("outcomes").innerHTML = nl2br(data?.outcomes);
      document.getElementById("Objective").innerHTML = nl2br(data?.objective);
    }
  }, [data?.outcomes, data?.objective,count])


  const getData = (dat, index) => {
    return <tr style={tabledata}>
      {Object.keys(dat).map(column => {
        return <td style={td}>{data.Attendances[index][column]}</td>
      })}
    </tr>
  };

  const htmlToPdf = () => {
    setLoading(true);
    var doc = new jsPDF();

    const printElement = document.getElementById("page");
    doc.html(printElement, {
      callback: function (doc) {
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          var img = new Image();
          img.src = '../../../../images/Chitkara.png';
          doc.addImage(img, 'png', 8, 9, 37, 14)
          doc.setFontSize(15);
          doc.setTextColor(0);
          doc.text(doc.internal.pageSize.getWidth() / 1.8, 18, `${data?.template?.department?.name}`, {
            color: "black",
            align: 'center',
          });
          if (data?.template?.department?.name.trim() != data?.template?.brand?.name.trim()) {
            doc.text(doc.internal.pageSize.getWidth() / 1.8, 27, `${data?.template?.brand?.name}`, {
              color: "black",
              align: 'center',
            });
          }
          doc.setFontSize(8);
          doc.setTextColor(0);

          doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 5, `Page ${i} of ${totalPages}`);
          doc.setFontSize(7);
          doc.setTextColor(0);
          doc.text(5, doc.internal.pageSize.getHeight() - 5, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
        }

        doc.save(`${data?.template?.name}.pdf`);
        setLoading(false);
      },
      margin: [30, 5, 30, 5],
      autoPaging: 'text',
      width: 195, //target width in the PDF document
      windowWidth: 800 //window width in CSS pixels
    });
  }

  const wordFormat = () => {
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    var postHtml = "</body></html>";

    var html = preHtml + document.getElementById("page").innerHTML + postHtml;

    var blob = new Blob(['\ufeff', html], {
      type: 'application/msword'
    });

    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);


    var filename = data?.template?.name ? data?.template?.name + '.doc' : 'document.doc';


    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {

      downloadLink.href = url;
      downloadLink.download = filename;
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  }

  const arrayBufferToBase64 = (buffer) =>{
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
        return btoa(binary); 
  }


  const converPdfDevisionWise = async() => {
    setLoading(true);
    let total = 2;
    if(data?.Attendances){
      total = 3;
    }

      const doc = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 190;
      const pageHeight = 295;
      const firstDivCanvas = await html2canvas(document.getElementById('firstDivision'),{scale: 1, 
        width: window.innerWidth/1.365,
        height: document.getElementById('firstDivision').offsetHeight});
      const firstDivImgData = firstDivCanvas.toDataURL('image/png');
      const firstDivHeight = (firstDivCanvas.height * (imgWidth)) / (firstDivCanvas.width);

          var img = new Image();
          img.src = '../../../../images/Chitkara.png';
          doc.addImage(img, 'png', 8, 9, 37, 14)
          doc.setFontSize(12);
          doc.setTextColor(0);
          doc.text(doc.internal.pageSize.getWidth() / 1.8, 12, `${data?.template?.department?.name}`, {
            color: "black",
            align: 'center',
          });
          if (data?.template?.department?.name.trim() != data?.template?.brand?.name.trim()) {
            doc.text(doc.internal.pageSize.getWidth() / 1.8, 21, `${data?.template?.brand?.name}`, {
              color: "black",
              align: 'center',
            });
          }
          doc.setFontSize(8);
          doc.setTextColor(0);

          doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 2, `Page ${1} of ${total}`);
          doc.setFontSize(7);
          doc.setTextColor(0);
          doc.text(5, doc.internal.pageSize.getHeight() - 2, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
          doc.addImage(firstDivImgData, 'PNG', 10, 28, imgWidth, firstDivHeight);
          // -----------------------------------------------------------------------
          const secoundDivCanvas = await html2canvas(document.getElementById('SecoundDevision'),{scale: 1, 
            width: window.innerWidth/1.365,
            height: document.getElementById('SecoundDevision').offsetHeight});
          const secoundDivImgData = secoundDivCanvas.toDataURL('image/png');
          const secoundDivHeight = (secoundDivCanvas.height * (imgWidth*1.18)) / secoundDivCanvas.width;

          doc.addPage();
          img.src = '../../../../images/Chitkara.png';
          doc.addImage(img, 'png', 8, 9, 37, 14)
          doc.setFontSize(12);
          doc.setTextColor(0);
          doc.text(doc.internal.pageSize.getWidth() / 1.8, 12, `${data?.template?.department?.name}`, {
            color: "black",
            align: 'center',
          });

          if (data?.template?.department?.name.trim() != data?.template?.brand?.name.trim()) {
            doc.text(doc.internal.pageSize.getWidth() / 1.8, 21, `${data?.template?.brand?.name}`, {
              color: "black",
              align: 'center',
            });
          }
          doc.setFontSize(8);
          doc.setTextColor(0);

          doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 2, `Page ${2} of ${total}`);
          doc.setFontSize(7);
          doc.setTextColor(0);
          doc.text(5, doc.internal.pageSize.getHeight() - 2, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
          doc.addImage(secoundDivImgData, 'PNG', 10, 40, imgWidth, secoundDivHeight);


          //-----------------------------------------------------------------------------------
          if (data?.Attendances) {
            // Capture the element as a canvas
            const originalCanvas = await html2canvas(document.getElementById('ThirdDecvision'), {
              scale: 1, 
              width: window.innerWidth/1.365,
              height: document.getElementById('firstDivision').offsetHeight - 30
            });
            
            // Get page dimensions
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
          
            // Calculate image dimensions while maintaining aspect ratio
            const imgWidth = pageWidth - 20; // leaving some margin
            const aspectRatio = originalCanvas.height / originalCanvas.width;
            const imgHeight = imgWidth * aspectRatio;
          
            // Define the half heights
            const halfHeight = originalCanvas.height / 2;
          
            // Create two new canvases for the top and bottom halves
            const canvasTop = document.createElement('canvas');
            const canvasBottom = document.createElement('canvas');
          
            // Set canvas dimensions
            canvasTop.width = originalCanvas.width;
            canvasTop.height = halfHeight;
            canvasBottom.width = originalCanvas.width;
            canvasBottom.height = halfHeight;
          
            const ctxTop = canvasTop.getContext('2d');
            const ctxBottom = canvasBottom.getContext('2d');
          
            // Draw the top half of the original canvas onto canvasTop
            ctxTop.drawImage(originalCanvas, 0, 0, originalCanvas.width, halfHeight, 0, 0, canvasTop.width, canvasTop.height);
          
            // Draw the bottom half of the original canvas onto canvasBottom
            ctxBottom.drawImage(originalCanvas, 0, halfHeight, originalCanvas.width, halfHeight, 0, 0, canvasBottom.width, canvasBottom.height);
          
            // Convert both halves to data URLs
            const topImgData = canvasTop.toDataURL('image/png');
            const bottomImgData = canvasBottom.toDataURL('image/png');
          
            // Add the top half image to the first page of the PDF
            doc.addPage();
            var img = new Image();
            img.src = '../../../../images/Chitkara.png';
            doc.addImage(img, 'png', 8, 9, 37, 14)
            doc.setFontSize(12);
            doc.setTextColor(0);
            doc.text(doc.internal.pageSize.getWidth() / 1.8, 12, `${data?.template?.department?.name}`, {
              color: "black",
              align: 'center',
            });
            if (data?.template?.department?.name.trim() != data?.template?.brand?.name.trim()) {
              doc.text(doc.internal.pageSize.getWidth() / 1.8, 21, `${data?.template?.brand?.name}`, {
                color: "black",
                align: 'center',
              });
            }
            doc.setFontSize(8);
            doc.setTextColor(0);
  
            doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 5, `Page ${1} of ${total}`);
            doc.setFontSize(7);
            doc.setTextColor(0);
            doc.text(5, doc.internal.pageSize.getHeight() - 5, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
            doc.setFontSize(8);
            doc.setTextColor(0);
            let currentPage = doc.internal.getNumberOfPages();
            doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 5, `Page ${currentPage} of ${total}`);
            doc.setFontSize(7);
            doc.setTextColor(0);
            doc.text(5, doc.internal.pageSize.getHeight() - 5, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
            const topAspectRatio = canvasTop.height / canvasTop.width;
            const topImgHeight = imgWidth * topAspectRatio;
            doc.addImage(topImgData, 'PNG', 10, 40, imgWidth, topImgHeight);
          
            // Add the bottom half image to the next page of the PDF
            doc.addPage();
            var img = new Image();
            img.src = '../../../../images/Chitkara.png';
            doc.addImage(img, 'png', 8, 9, 37, 14)
            doc.setFontSize(12);
            doc.setTextColor(0);
            doc.text(doc.internal.pageSize.getWidth() / 1.8, 12, `${data?.template?.department?.name}`, {
              color: "black",
              align: 'center',
            });
            if (data?.template?.department?.name.trim() != data?.template?.brand?.name.trim()) {
              doc.text(doc.internal.pageSize.getWidth() / 1.8, 21, `${data?.template?.brand?.name}`, {
                color: "black",
                align: 'center',
              });
            }
            doc.setFontSize(8);
            doc.setTextColor(0);
  
            doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 5, `Page ${1} of ${total}`);
            doc.setFontSize(7);
            doc.setTextColor(0);
            doc.text(5, doc.internal.pageSize.getHeight() - 5, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
          
            const bottomAspectRatio = canvasBottom.height / canvasBottom.width;
            const bottomImgHeight = imgWidth * bottomAspectRatio;
            doc.addImage(bottomImgData, 'PNG', 10, 40, imgWidth, bottomImgHeight);
          
            // Add footer and other text (if needed)
            doc.setFontSize(8);
            doc.setTextColor(0);
            currentPage = doc.internal.getNumberOfPages();
            doc.text(doc.internal.pageSize.getWidth() - 24, doc.internal.pageSize.getHeight() - 5, `Page ${currentPage} of ${total}`);
            doc.setFontSize(7);
            doc.setTextColor(0);
            doc.text(5, doc.internal.pageSize.getHeight() - 5, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
          }
          
          // Save the PDF with the template name
          doc.save(`${data?.template?.name}`);
          setLoading(false);
  }

  if (count>0) {
    return (<div className='container w-75 p-3' >
      <div className='Form-buttons mt-1'>
        <button type="button" className='cancel mb-2' onClick={() => { setLoading(true); wordFormat(); setLoading(false); }}>Word Format</button>
        {/* <button type="button" onClick={htmlToPdf} className='cancel mb-2'>{loading ? 'PleaseWait...' : 'Old Download'}</button> */}
        <button type="button" onClick={converPdfDevisionWise} className='cancel mb-2'>{loading ? 'PleaseWait...' : 'Download'}</button>
      </div>
      <div id="page" >

        {/* /----------------------------------------------------------------------------/ */}

        <div id="firstDivision">
          <table style={table}>

            <tr style={headingTabledata}>
              <th colspan="2" style={HeadingAligne}>EVENT DETAILS</th>
            </tr>

            <tr style={tabledata}>
              <td style={td}>EVENT TYPE</td>
              <td style={textAlign}>{data?.template.secoundType ? data?.template.secoundType?.toUpperCase() : data?.template?.type?.toUpperCase()}</td>
            </tr>

            <tr style={tabledata}>
              <td style={td}>TOPIC</td>
              <td style={textAlign}>{data?.template?.name?.toUpperCase()}</td>
            </tr>

            <tr style={tabledata}>
              <td style={td}>DATE</td>
              <td style={textAlign}>{data?.template?.start_date?.toUpperCase()} to {data?.template?.end_date?.toUpperCase()}</td>
            </tr>

            <tr style={tabledata}>
              <td style={td}>MODE</td>
              <td style={textAlign}>{data?.template?.location?.toUpperCase()}</td>
            </tr>


            {data?.template?.address_line_2 && <tr style={tabledata}>
              <td style={td}>VENUE</td>
              <td style={textAlign}> {data?.template?.address_line_2?.toUpperCase()}{data?.template?.address_line_1 ?` (${data?.template?.address_line_1?.toUpperCase()})`:""}</td>
            </tr>}

            <tr style={tabledata}>
              <td style={td} >ORGANIZER NAME</td>
              <td style={normalText}>{data?.template?.organized_by?.toUpperCase()}</td>
            </tr>

            {data.template.resource_persons && data?.template?.resource_persons[0]['name'] != "" && <tr style={tabledata}>
              <td style={td} >RESOURCE PERSON</td>
              <td style={normalText}>{data?.template?.resource_persons?.map((d, index) =>
                index === data?.template?.resource_persons?.length - 1 ? `${d.name?.toUpperCase()}, ${d.designation?.toUpperCase()}` : `${d.name?.toUpperCase()}, ${d.designation?.toUpperCase()} | `)}</td>
            </tr>}

            <tr style={tabledata}>
              <td style={td}>NO. OF PARTICIPANTS</td>
              <td style={textAlign}>{data?.participants ? data.participants : data?.template?.registrations?.length}</td>
            </tr>

            <tr style={tabledata}>
              <td style={td}>SDG NO</td>
              <td style={normalText}>{data?.template?.sdg?.map((d, index) =>
                index === data?.template?.sdg?.length - 1 ? `${d.label.toUpperCase()}` : `${d.label.toUpperCase()},  `)}</td></tr>
          </table>


          <h5 className='mb-2'>OBJECTIVE:</h5>
          <div id='Objective' style={{
            fontSize: '2.27vh', width: '100%',
            marginLeft: '10px', outline: 'none', border: 'none'
          }}>
          </div >

          <div style={{ width: '100%' }}>
            {data.Description && <h5 className='mb-2 mt-3'>DESCRIPTION:</h5>}
            <p style={justifyAlign}>{data?.Description}</p>
          </div>

          <h5>OUTCOMES:</h5>
          <div id='outcomes' style={{ fontSize: '2.27vh', width: '100%', marginLeft: '10px', outline: 'none', border: 'none' }} >

            {/* <textarea style={{ fontSize: '13px', textAlign: 'justify', width:'100%', marginLeft:'20px', outline: 'none', height: textAreaHeight, border: 'none' }} ref={textAreaRef} value={data?.outcomes} /> */}
          </div >
        </div>

        {/* /----------------------------------------------------------------------------------------------------------------/ */}


        <div id='SecoundDevision'>
          {data && <div className="pdf-gallary-thumbnail">
            {count>0 && data?.EventsPhotos?.map((element, index) => { 
              if(index <= 5){
                return (
                  <div className='pdf-ing-cont'>
                    <img className='pdf-img'
                      id={`${index}`}
                      src={`${images[element?.imageUrl].url}`}
                      alt="Uploaded_Image" />
                    <p className='pdf-para'>{element?.caption}</p>
                  </div>);
              }
            })}
          </div>}
        </div>


        {/* /------------------------------------------------------------------------------------/ */}

        <div id='ThirdDecvision'>
          {data?.Attendances &&
            <table className='mt-2' style={table}>
              <tr style={headingTabledata}>
                {Object?.keys(data?.Attendances[0])?.map(column => {
                  return <th style={HeadingAligne}>{column}</th>
                })} 
              </tr>
              {
                data?.Attendances?.map((x, index) => {
                  return getData(x, index);
                })
              }
            </table>
          }
        </div>

        {/* /-----------------------------------------------------------------------------------/ */}

      </div>
    </div>)
  }

  else {
    return (<h1><LoadingSpinner /></h1>)
  }
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventReport);


